import { CargoDoc } from './CargoDoc'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { Company } from '@/class/model/mdm/Company'
import $store from '@/store'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getOtherCharge, toInsureForAe, toInsureForAi } from '@/api/AirExport/airCargoDoc'
import ColumnUtils from '@/utils/ColumnUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export class AirCargoDoc extends CargoDoc {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get cWeight() {
    return this._data.cWeight
  }
  set cWeight(cWeight) {
    this._data.cWeight = cWeight
  }
  get iataCode() {
    return this._data.iataCode
  }
  set iataCode(iataCode) {
    this._data.iataCode = iataCode
  }
  get accountCode() {
    return this._data.accountCode
  }
  set accountCode(accountCode) {
    this._data.accountCode = accountCode
  }
  get handingInfo() {
    return this._data.handingInfo
  }
  set handingInfo(handingInfo) {
    this._data.handingInfo = handingInfo
  }
  get accountingInfo() {
    return this._data.accountingInfo
  }
  set accountingInfo(accountingInfo) {
    this._data.accountingInfo = accountingInfo
  }
  get tsRemarks() {
    return this._data.tsRemarks
  }
  set tsRemarks(tsRemarks) {
    this._data.tsRemarks = tsRemarks
  }
  get airportOfDeparture() {
    return this._data.airportOfDeparture
  }
  set airportOfDeparture(airportOfDeparture) {
    this._data.airportOfDeparture = airportOfDeparture
  }
  get airportOfDestination() {
    return this._data.airportOfDestination
  }
  set airportOfDestination(airportOfDestination) {
    this._data.airportOfDestination = airportOfDestination
  }
  get podTo() {
    return this._data.podTo
  }
  set podTo(podTo) {
    this._data.podTo = podTo
  }
  get carrierBy() {
    return this._data.carrierBy
  }
  set carrierBy(carrierBy) {
    this._data.carrierBy = carrierBy
  }
  get podTo1() {
    return this._data.podTo1
  }
  set podTo1(podTo1) {
    this._data.podTo1 = podTo1
  }
  get carrierBy1() {
    return this._data.carrierBy1
  }
  set carrierBy1(carrierBy1) {
    this._data.carrierBy1 = carrierBy1
  }
  get podTo2() {
    return this._data.podTo2
  }
  set podTo2(podTo2) {
    this._data.podTo2 = podTo2
  }
  get carrierBy2() {
    return this._data.carrierBy2
  }
  set carrierBy2(carrierBy2) {
    this._data.carrierBy2 = carrierBy2
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get wtVal() {
    return this._data.wtVal
  }
  set wtVal(wtVal) {
    this._data.wtVal = wtVal
  }
  get other() {
    return this._data.other
  }
  set other(other) {
    this._data.other = other
  }
  get carriageDv() {
    return this._data.carriageDv
  }
  set carriageDv(carriageDv) {
    this._data.carriageDv = carriageDv
  }
  get dvForCustoms() {
    return this._data.dvForCustoms
  }
  set dvForCustoms(dvForCustoms) {
    this._data.dvForCustoms = dvForCustoms
  }
  get insuredAmount() {
    return this._data.insuredAmount
  }
  set insuredAmount(insuredAmount) {
    this._data.insuredAmount = insuredAmount
  }
  get pp1() {
    return this._data.pp1
  }
  set pp1(pp1) {
    this._data.pp1 = pp1
  }
  get pp2() {
    return this._data.pp2
  }
  set pp2(pp2) {
    this._data.pp2 = pp2
  }
  get pp3() {
    return this._data.pp3
  }
  set pp3(pp3) {
    this._data.pp3 = pp3
  }
  get pp4() {
    return this._data.pp4
  }
  set pp4(pp4) {
    this._data.pp4 = pp4
  }
  get pp5() {
    return this._data.pp5
  }
  set pp5(pp5) {
    this._data.pp5 = pp5
  }
  get pp6() {
    return this._data.pp6
  }
  set pp6(pp6) {
    this._data.pp6 = pp6
  }
  get cc1() {
    return this._data.cc1
  }
  set cc1(cc1) {
    this._data.cc1 = cc1
  }
  get cc2() {
    return this._data.cc2
  }
  set cc2(cc2) {
    this._data.cc2 = cc2
  }
  get cc3() {
    return this._data.cc3
  }
  set cc3(cc3) {
    this._data.cc3 = cc3
  }
  get cc4() {
    return this._data.cc4
  }
  set cc4(cc4) {
    this._data.cc4 = cc4
  }
  get cc5() {
    return this._data.cc5
  }
  set cc5(cc5) {
    this._data.cc5 = cc5
  }
  get cc6() {
    return this._data.cc6
  }
  set cc6(cc6) {
    this._data.cc6 = cc6
  }
  get rateClass() {
    return this._data.rateClass
  }
  set rateClass(rateClass) {
    this._data.rateClass = rateClass
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate
  }
  get rateCharge() {
    return this._data.rateCharge
  }
  set rateCharge(rateCharge) {
    this._data.rateCharge = rateCharge
  }
  get dimension() {
    return this._data.dimension
  }
  set dimension(dimension) {
    this._data.dimension = dimension
  }
  get remark1() {
    return this._data.remark1
  }
  set remark1(remark1) {
    this._data.remark1 = remark1
  }
  get remark2() {
    return this._data.remark2
  }
  set remark2(remark2) {
    this._data.remark2 = remark2
  }
  get signByShipper() {
    return this._data.signByShipper
  }
  set signByShipper(signByShipper) {
    this._data.signByShipper = signByShipper
  }
  get signByCarrier() {
    return this._data.signByCarrier
  }
  set signByCarrier(signByCarrier) {
    this._data.signByCarrier = signByCarrier
  }
  get issuedBy() {
    return this._data.issuedBy
  }
  set issuedBy(issuedBy) {
    this._data.issuedBy = issuedBy
  }
  get kglb() {
    return this._data.kglb
  }
  set kglb(kglb) {
    this._data.kglb = kglb
  }
  get weightImperial() {
    return this._data.weightImperial
  }
  set weightImperial(weightImperial) {
    this._data.weightImperial = weightImperial || 0
  }
  get cubAgeImperial() {
    return this._data.cubAgeImperial
  }
  set cubAgeImperial(cubAgeImperial) {
    this._data.cubAgeImperial = cubAgeImperial || 0
  }
  get chargeWeightImperial() {
    return this._data.chargeWeightImperial
  }
  set chargeWeightImperial(chargeWeightImperial) {
    this._data.chargeWeightImperial = chargeWeightImperial || 0
  }
  get freightAmount() {
    return this._data.freightAmount
  }
  set freightAmount(freightAmount) {
    this._data.freightAmount = freightAmount
  }
  get freightType() {
    return this._data.freightType
  }
  set freightType(freightType) {
    this._data.freightType = freightType
  }
  get freightCurrency() {
    return this._data.freightCurrency
  }
  set freightCurrency(freightCurrency) {
    this._data.freightCurrency = freightCurrency
  }
  get signatureWeight() {
    return this._data.signatureWeight
  }
  set signatureWeight(signatureWeight) {
    this._data.signatureWeight = signatureWeight
  }
  get signatureDimensions() {
    return this._data.signatureDimensions
  }
  set signatureDimensions(signatureDimensions) {
    this._data.signatureDimensions = signatureDimensions
  }
  get signatureRemark() {
    return this._data.signatureRemark
  }
  set signatureRemark(signatureRemark) {
    this._data.signatureRemark = signatureRemark
  }
  get foldedWeightRemark() {
    return this._data.foldedWeightRemark
  }
  set foldedWeightRemark(foldedWeightRemark) {
    this._data.foldedWeightRemark = foldedWeightRemark
  }
  get cTotal() {
    return this._data.cTotal
  }
  set cTotal(cTotal) {
    this._data.cTotal = cTotal
  }
  get otherCharge() {
    return this._data.otherCharge
  }
  set otherCharge(otherCharge) {
    this._data.otherCharge = otherCharge
  }
  get slac() {
    return this._data.slac
  }
  set slac(slac) {
    this._data.slac = slac
  }

  async newCargoDoc(model, docType) {
    const cargoDoc = new AirCargoDoc().fillDefaultValue().getData()
    cargoDoc.cubage = model.cubageActual
    cargoDoc.weight = model.weightActual
    if (model.lob === 'AE') {
      cargoDoc.cWeight = (new AirExportJob(model)).cWeight
      cargoDoc.slac = (new AirExportJob(model)).slac
    }
    cargoDoc.jobUuid = model.uuid
    cargoDoc.docType = docType
    cargoDoc.wtVal = 'PP'
    cargoDoc.other = 'PP'
    cargoDoc.rateCharge = 'AS ARRANGED'
    cargoDoc.cTotal = CargoDocConsts.HAWB === docType ? 'AS ARRANGED' : ''
    cargoDoc.pp4 = CargoDocConsts.HAWB === docType ? 'AS ARRANGED' : ''
    cargoDoc.pp5 = CargoDocConsts.MAWB === docType ? 'AS ARRANGED' : ''
    if (CargoDocConsts.MAWB === docType) {
      cargoDoc.currency = RateUtil.localCurrencyByOffice2()
      cargoDoc.currency = cargoDoc.currency === 'RMB' ? 'CNY' : cargoDoc.currency
    } else {
      cargoDoc.currency = 'CNY'
    }
    cargoDoc.carriageDv = 'N.V.D'
    cargoDoc.insuredAmount = 'NIL'
    cargoDoc.signDateBL = model.etd
    cargoDoc.kglb = 'K'
    await this.copyInfoFromAirExportJob(cargoDoc, model)
    return cargoDoc
  }
  /**
   * 复制Job中的信息
   */
  async copyInfoFromAirExportJob(cargoDoc, job) {
    if (cargoDoc.state > 1) return
    const carrier = await Company.getCompanyById(job.carrierId)
    cargoDoc.carrierBy = carrier == null ? '' : carrier.shortName
    cargoDoc.podTo = job.destinationPortCode
    if (job.lob === 'AE') {
      await this.copyTransitPortInfo(cargoDoc, new AirExportJob(job))
    }

    // 0.Console: MAWB-> UBI, HAWB-> 手动输入
    // 1.Co-Loader: HAWB-> UBI
    // 2.Direct: MAWB->手动输入
    // 3.Back To Back: MAWB-> UBI, HAWB-> 手动输入
    let operateType = 0
    if (job.lob === 'AE') {
      operateType = (new AirExportJob(job)).operateType
    }
    if (job.lob === 'AI') {
      // operateType = AirImportJob(job).operateType
    }
    if (cargoDoc.docType === CargoDocConsts.MAWB && (operateType === 0 || operateType === 3)) {
      const office = $store.getters.currentOffice
      if (office) {
        cargoDoc.shipperLine1 = office.airAddressLine1
        cargoDoc.shipperLine2 = office.airAddressLine2
        cargoDoc.shipperLine3 = office.airAddressLine3
        cargoDoc.shipperLine4 = office.airAddressLine4
        cargoDoc.shipperLine5 = office.airAddressLine5
        cargoDoc.shipperLine6 = office.airAddressLine6
      }

      const agent = await Company.getCompanyById(job.destinationAgent)
      if (agent) {
        const overseaAgentDetail = await new Company(agent).getOverseaAgentDetail()
        if (overseaAgentDetail) {
          cargoDoc.consigneeLine1 = agent.overseaAgentDetail.blAddress
          cargoDoc.consigneeLine2 = agent.overseaAgentDetail.blAddressLine2
          cargoDoc.consigneeLine3 = agent.overseaAgentDetail.blAddressLine3
          cargoDoc.consigneeLine4 = agent.overseaAgentDetail.blAddressLine4
          cargoDoc.consigneeLine5 = agent.overseaAgentDetail.blAddressLine5
          cargoDoc.consigneeLine6 = agent.overseaAgentDetail.blAddressLine6
        }
      }
    }

    const airports = await getSpecificBasicData(basicCacheKeys.basic_data_Airport)
    const ports = airports.filter(p => p.code === job.loadingPortCode)
    if (ports.length > 0) {
      // 提单起运港
      cargoDoc.airportOfDeparture = ports[0].englishName
    }
    const desPorts = airports.filter(p => p.code === job.destinationPortCode)
    if (desPorts.length > 0) {
      // 提单目的港
      cargoDoc.airportOfDestination = desPorts[0].englishName
    }
    cargoDoc.quantity = job.quantityActual
    // 重量
    cargoDoc.weight = job.weightActual
    // 体积
    cargoDoc.cubage = job.cubageActual
    cargoDoc.releaseType = 1
    // cargoDoc.issuerBL = 'UBI'
    ColumnUtils.customOrderFormTypeFunc(cargoDoc)
    cargoDoc.blNumber = 'THREE'
  }
  // 拷贝二、三乘信息
  async copyTransitPortInfo(cargoDoc, job) {
    const carrier = await Company.getCompanyById(job.carrierId)
    const carrier1 = await Company.getCompanyById(job.secondCarrierId)
    const carrier2 = await Company.getCompanyById(job.thirdCarrierId)
    if (job.transfering) { // 针对于有中转的场景, 目的港属于尾程
      if (job.secondPortCode) { // 二程存在
        cargoDoc.podTo = job.secondPortCode
        cargoDoc.carrierBy = !carrier1 ? '' : carrier1.shortName
        if (job.thirdPortCode) { // 有三程
          cargoDoc.podTo1 = job.thirdPortCode
          cargoDoc.carrierBy1 = !carrier2 ? '' : carrier2.shortName
          cargoDoc.podTo2 = job.destinationPortCode
          cargoDoc.carrierBy2 = !carrier ? '' : carrier.shortName
        } else { // 没有三程
          cargoDoc.podTo1 = job.destinationPortCode
          cargoDoc.carrierBy1 = !carrier ? '' : carrier.shortName
          cargoDoc.podTo2 = ''
          cargoDoc.carrierBy2 = ''
        }
      } else { // 没有二程 提单数据清空
        cargoDoc.podTo1 = ''
        cargoDoc.carrierBy1 = ''
        cargoDoc.podTo2 = ''
        cargoDoc.carrierBy2 = ''
      }
    } else { // 没有中转港，提单数据清空
      cargoDoc.podTo1 = ''
      cargoDoc.carrierBy1 = ''
      cargoDoc.podTo2 = ''
      cargoDoc.carrierBy2 = ''
    }
  }
  // 基本属性的复制
  copyBasic(doc) {
    super.copyBasic(doc)
    this.iataCode = doc.iataCode
    this.accountCode = doc.accountCode
    this.accountingInfo = doc.accountingInfo
    this.airportOfDeparture = doc.airportOfDeparture
    this.podTo = doc.podTo
    this.carrierBy = doc.carrierBy
    this.podTo1 = doc.podTo1
    this.carrierBy1 = doc.carrierBy1
    this.podTo2 = doc.podTo2
    this.carrierBy2 = doc.carrierBy2
    this.currency = doc.currency
    this.wtVal = doc.wtVal
    this.other = doc.other
    this.carriageDv = doc.carriageDv
    this.dvForCustoms = doc.dvForCustoms
    this.airportOfDestination = doc.airportOfDestination
    this.insuredAmount = doc.insuredAmount
    this.handingInfo = doc.handingInfo
    this.otherCharge = doc.otherCharge
    this.signByCarrier = doc.signByCarrier
    this.signByShipper = doc.signByShipper
    this.remark1 = doc.remark1
    this.remark2 = doc.remark2
    this.dimension = doc.dimension
    this.rateClass = doc.rateClass
    this.cWeight = doc.cWeight
    this.rateCharge = doc.rateCharge
    this.cargoEnglishName = doc.cargoEnglishName
    this.pp1 = doc.pp1
    this.pp2 = doc.pp2
    this.pp3 = doc.pp3
    this.pp4 = doc.pp4
    this.pp5 = doc.pp5
    this.pp6 = doc.pp6
    this.cc1 = doc.cc
    this.cc2 = doc.cc2
    this.cc3 = doc.cc3
    this.cc4 = doc.cc4
    this.cc5 = doc.cc5
    this.cc6 = doc.cc6
  }
  async getOtherCharge() {
    const data = this._data
    if (typeof data.otherCharge !== 'object') {
      if (data.uuid) {
        await getOtherCharge({ 'cargoDocUuid': data.uuid }).then(res => {
          if (res.data) {
            data.otherCharge = res.data
          } else {
            data.otherCharge = []
          }
        })
      } else {
        data.otherCharge = []
      }
    }
    return data.otherCharge
  }
  // 投保 空出
  static async toInsureForAe(seaCargoDoc, job, office) {
    return await toInsureForAe({ seaCargoDoc, job, office }).then(res => res.data)
  }
  // 投保 空进
  static async toInsureForAi(seaCargoDoc, job, office) {
    return await toInsureForAi({ seaCargoDoc, job, office }).then(res => res.data)
  }
}
